import './comparison-table.scss';

class ComparisonTable {
    constructor (element, options) {
        const settings = {
            initAttr: 'data-comparison-table'
        };

        this.settings = Object.assign({}, settings, options);
        this.$comparisonTable = element;
        this.$comparisonTableParameter = this.$comparisonTable.querySelector('[data-comparison-table="parameter"]');
        this.$comparisonTableHeaders = this.$comparisonTable.querySelectorAll('[data-comparison-table="header"]');

        this.initialize();
    }

    initialize () {
        this.calculateOffset();
        this.setEvents();
    }

    setEvents () {
        window.resizeHandler.customFunctions.push(() => {
            this.calculateOffset();
        });
    }

    calculateOffset () {
        console.log('calculate offset');
        let headerMaxHeight = 0;
        this.$comparisonTableHeaders.forEach($header => {
            headerMaxHeight = $header.offsetHeight > headerMaxHeight ? $header.offsetHeight : headerMaxHeight;
        });

        this.$comparisonTableParameter.style.marginTop = headerMaxHeight + 'px';
    }
}

export { ComparisonTable };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    const $$comparisonTable = $context.querySelectorAll('[data-comparison-table="root"]');

    if ($$comparisonTable.length > 0) {
        $$comparisonTable.forEach(($comparisonTable) => {
            const comparisonTable = new ComparisonTable($comparisonTable); // eslint-disable-line
        });
    }
});
